const firebaseConfig = {
    apiKey: "AIzaSyCvwJZal6cx7CwonEajS631EvoCi8zt5EE",
    authDomain: "skillforge-01185.firebaseapp.com",
    projectId: "skillforge-01185",
    storageBucket: "skillforge-01185.firebasestorage.app",
    messagingSenderId: "831066278917",
    appId: "1:831066278917:web:5675422bd8b322d95ae06c",
    measurementId: "G-GYKRX0HBQP"
  };

export { firebaseConfig };